import { FetchUserQuery } from '../getUserTaxonomy/user.generated';

export const updateUserTaxonomyKeys = (user: FetchUserQuery['user']) => ({
    user_uuid: user?.userUuid,
    user_id: user?.userId,
    registered: user?.registered,
    signed_in_status: user?.loggedIn ? 'signed in' : 'signed out',
    about_me_status: user?.senderPropertyStatus,
    registration_platform: user?.registrationSources?.join(', '),
    user_creation_date: user?.creationDate
});
